var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduledMaintenance = function SvgScheduledMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M57.92 9.252a18 18 0 0 0-20.998 24.823 2 2 0 0 1-.408 2.239L13.481 59.347a5.071 5.071 0 0 0 7.172 7.172l23.033-23.033a2 2 0 0 1 2.239-.408A18 18 0 0 0 70.748 22.08L60.414 32.414l-.014.014a5.333 5.333 0 0 1-7.467 0l-.014-.014-5.333-5.333-.014-.015a5.333 5.333 0 0 1 0-7.466l.014-.014zM49.378 5.01a22 22 0 0 1 13.013 1.6 2 2 0 0 1 .59 3.236L50.423 22.405a1.334 1.334 0 0 0 0 1.856l5.316 5.316a1.333 1.333 0 0 0 1.855 0l12.559-12.558a2 2 0 0 1 3.236.59 22 22 0 0 1-27.82 29.65L23.482 69.347A9.071 9.071 0 1 1 10.652 56.52l22.09-22.089A22 22 0 0 1 49.377 5.01",
    clipRule: "evenodd"
  })));
};
export default SvgScheduledMaintenance;